import React from 'react';
import PropTypes from 'prop-types';
import { NavFragment } from '@paypalcorp/globalnavsdk/NavFragment';

export default class Headercontainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <NavFragment type="header" />;
  }
}
Headercontainer.propTypes = {
  isLoggedIn: PropTypes.string,
  isNewMppEnabled: PropTypes.string,
};
